import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfa-new-device1',
  templateUrl: './mfa-new-device1.component.html',
  styleUrls: ['./mfa-new-device1.component.scss']
})
export class MfaNewDevice1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
